export default __webpack_public_path__ + "static/media/faleConosco.90a87674.svg";